"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageProvider = exports.useLanguage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var translations_1 = require("../translations");
var LanguageContext = (0, react_1.createContext)(undefined);
var useLanguage = function () {
    var context = (0, react_1.useContext)(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
exports.useLanguage = useLanguage;
var LanguageProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)('es'), currentLanguage = _b[0], setCurrentLanguage = _b[1];
    // Google Analytics tracking function
    var trackLanguageEvent = function (action, language, source) {
        var gtag = window.gtag;
        if (typeof window !== 'undefined' && gtag) {
            gtag('event', action, {
                event_category: 'language_system',
                event_label: "".concat(language, "_").concat(source || 'default'),
                value: 1,
                language: language,
                source: source || 'default'
            });
        }
    };
    // Load language from localStorage on mount
    (0, react_1.useEffect)(function () {
        var savedLanguage = localStorage.getItem('language');
        if (savedLanguage && translations_1.translations[savedLanguage]) {
            setCurrentLanguage(savedLanguage);
            // Track language loaded from localStorage
            trackLanguageEvent('language_loaded', savedLanguage, 'localStorage');
        }
        else {
            // Track default language set
            trackLanguageEvent('language_default', 'es', 'initial');
        }
    }, []);
    var changeLanguage = function (language) {
        setCurrentLanguage(language);
        localStorage.setItem('language', language);
        document.documentElement.lang = language;
        document.title = translations_1.translations[language].meta.homeTitle;
        // Track language change in context
        trackLanguageEvent('language_changed', language, 'user_selection');
    };
    // Simple translation function
    var t = function (key) {
        var keys = key.split('.');
        var value = translations_1.translations[currentLanguage];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            }
            else {
                // Fallback to Spanish if translation not found
                value = translations_1.translations.es;
                for (var _a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
                    var fallbackKey = keys_2[_a];
                    if (value && typeof value === 'object' && fallbackKey in value) {
                        value = value[fallbackKey];
                    }
                    else {
                        return key; // Return the key if no translation found
                    }
                }
                break;
            }
        }
        return typeof value === 'string' ? value : key;
    };
    var value = {
        currentLanguage: currentLanguage,
        changeLanguage: changeLanguage,
        t: t,
    };
    return ((0, jsx_runtime_1.jsx)(LanguageContext.Provider, { value: value, children: children }));
};
exports.LanguageProvider = LanguageProvider;
